import { useBondRetrievalGuardianDropdowns } from "../../../pages/SHARED/Bond Retrieval/hooks/useBondRetrievalGuardianDropdowns";
import {
  mapProfessionalGuardianVA,
  mapProfessionalGuardianTrustee,
  mapProfessionalGuardianProbate,
} from "../../../pages/SHARED/Bond Retrieval/hooks/bondRetrievalGuardianMappers";

/**
 * Bond-creation principal steps share `/fields`, professional-guardian directory, and law-firm attorneys.
 * Guardianship **creation** UI uses `address` + `cell` on PG options (same shape as VA), not
 * `guardian_street_address_*` (that shape is for Bond Retrieval guardianship forms only).
 */
export const BOND_PRINCIPAL_KIND = Object.freeze({
  va: "va",
  trustee: "trustee",
  guardianship: "guardianship",
  probate: "probate",
});

const KIND_TO_MAP = {
  [BOND_PRINCIPAL_KIND.va]: mapProfessionalGuardianVA,
  [BOND_PRINCIPAL_KIND.trustee]: mapProfessionalGuardianTrustee,
  [BOND_PRINCIPAL_KIND.guardianship]: mapProfessionalGuardianVA,
  [BOND_PRINCIPAL_KIND.probate]: mapProfessionalGuardianProbate,
};

export function getPrincipalProfessionalGuardianMapper(kind) {
  const mapFn = KIND_TO_MAP[kind];
  if (!mapFn) {
    throw new Error(`BondPrincipalForm: unknown bond principal kind "${kind}"`);
  }
  return mapFn;
}

/**
 * Thin facade over {@link useBondRetrievalGuardianDropdowns} for `features/bonds` principal pages.
 */
export function useBondPrincipalDropdowns({ kind, attorneyLawFirmId, isGuest }) {
  return useBondRetrievalGuardianDropdowns({
    attorneyLawFirmId,
    mapProfessionalGuardian: getPrincipalProfessionalGuardianMapper(kind),
    isGuest: !!isGuest,
    attorneyFetchMode: "search",
  });
}
